import BlogPage from './BlogPage'

export default function NewsroomPage() {
  return <BlogPage publication="newsroom" />
}
